import React from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import "./Contact.css";
import { FaArrowRight } from "react-icons/fa";
import axios from "axios";
import { useState } from "react";
import { Link } from "react-router-dom";

const Contact = () => {

  const [formData, setFormData] = useState({
    url: "https://www.isolsgroup.com/contact",
    manager_id: "",
    pipeline_id: "14",
    source_id: "36",
    name: "New Let's Connect Request Received | ISOLS Group Website | Contact Page",
    contact_product: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    description: "",
    nspm: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
         const response = await axios.post(
        "https://erp.isolsgroup.com/api/v1/module/crm/leads/web_lead?id=101591&api_token=a1b962d0c1fb87354b47c32c88929ea2",
        formData,
        { headers: { "Content-Type": "application/json" } }
       );

      if (response.data && response.data._resultMessage) {
        setMessage(
          response.data._resultMessage.replace("{{ID}}", response.data.id)
        );
      } else {
        setMessage("Form submitted successfully!");
      }
    } catch (error) {
      console.error(error);
      setMessage("Error submitting form. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
      

    <div className="page-container">
      {/* Breadcrumbs Header */}
      <BreadcrumbsHeader 
        title="Contact" 
        backgroundImage="/images/breadcrumbs/contact3.jpg" 
      />
 

      {/* Contact Section */}
      <section className="section-contact-2">
        <div className="container">
          <div className="row">
            {/* Heading */}
            <div className="col-xs-12 col-sm-12">
              <div className="b-mod-heading text-center wow fadeInDown">
                <p className="first-heading font-secondary">
                  Looking for a reliable technology &amp; digital partner?
                </p>
                <h2 className="heading-line line-right customColor customPseudoElBg">
                  <strong>Get In Touch With Us Today</strong>
                </h2>
                <p className="second-heading font-additional">
                  Our orientation &amp; ideology focuses on:
                  <br />
                  Keep Your Clients Happy and they will Keep You Happy!
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-md-6 col-xs-12 col-sm-12 wow slideInLeft">
              <div className="footer-form wow fadeInDown" id="contact-form">
                
                  <form onSubmit={handleSubmit} className="form-message text-left flowlu-form">

                  <h2 className="footer-form-title" style={{ color: "#000" }}>
                    Let's Connect
                  </h2>

                  <div className="flowlu-row">

                    <select
                      name="contact_product"
                      onChange={handleChange}
                      value={formData.contact_product}
                      className="flowlu-input"
                      required
                      style={{ border: "1px solid #000", borderRadius: "0px" }}
                    >
                      <option value="">Select Enquiry For*</option>
                      <option value="Seeking New Product/Solution">Seeking New Product/Solution</option>
                      <option value="Products Alliance">Products Alliance</option>
                      <option value="Channel Partnership">Channel Partnership</option>
                      <option value="Employment / HR">Employment / HR</option>
                      <option value="Existing Client Help">Existing Client Help</option>
                      <option value="Investor Enquiry">Investor Enquiry</option>
                      <option value="Billing and Finance">Billing and Finance</option>
                      <option value="Others">Others</option>
                    </select>

                    <input
                      type="text"
                      name="contact_name"
                      placeholder="Your Name*"
                      required
                      onChange={handleChange}
                      className="flowlu-input"
                    />

                    <input
                      type="email"
                      name="contact_email"
                      placeholder="Email Address*"
                      required
                      onChange={handleChange}
                      className="flowlu-input"
                    />

                    <input
                      type="number"
                      name="contact_phone"
                      placeholder="Mobile Number"
                      required
                      onChange={handleChange}
                      className="flowlu-input"
                    />

                    <textarea
                      name="description"
                      rows="4"
                      placeholder="Type Your Query"
                      onChange={handleChange}
                      className="flowlu-input"
                      style={{ borderRadius: 0 }}
                    ></textarea>
                  </div>

                  <div className="flowlu-row flowlu-row-submit">
                    <button
                     disabled={loading}
                      className="flowlu-submit btn-default-arrow"
                       style={{ marginTop: "30px" }}>
                         {loading ? "Submitting..." : <><FaArrowRight/> Submit</>}
                    </button>
                  </div>

                </form>

                {/* Message Output */}
               

                  {message && (
                    <div
                      className="flowlu-notification"
                      style={{ marginTop: "10px", fontWeight: "bold", color: message.includes("Error") ? "red" : "green" }}
                    >
                      {message}
                    </div>
                  )}


              </div>
            </div>

   {/* Contact Infos */}
            <div className="col-md-6 col-xs-12 col-sm-12 wow slideInRight">
              {/* Corporate Office */}
              <div className="b-contact-info" style={{ marginBottom: "0px" }}>
                <h6 className="contact-info-title customPseudoElBg font-secondary">
                  Corporate Office: <span> Gurugram, Haryana, India</span>
                </h6>
                <ul className="list-unstyled">
                  <li>
                    <span>Address</span> Plot No. 698, Sector 45, Gurugram,
                    Haryana 122003, India
                  </li>
                  <li>
                    <span>Email</span>
                    <Link to="mailto:info@isolsgroup.com">info@isolsgroup.com</Link> &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span> phone</span>
                    <Link to="tel:+919555411411">(+91) 9555-411-411 (India)</Link>
                  </li>
                </ul>
                <div className="b-map-small-holder">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3508.131138560688!2d77.07253531507843!3d28.44546298249191!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d18946f5c854d%3A0xda95b0e3c86a03c5!2sISOLS+GROUP+-+Innovate+First%2C+Rule+Next...!5e0!3m2!1sen!2sin!4v1549305843089"
                    width="100%"
                    height="100"
                       title="Gurugram"
                    style={{ border: 0 }}
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

              {/* Branch Noida */}
              <div className="b-contact-info" style={{ marginBottom: "0px" }}>
                <h6 className="contact-info-title customPseudoElBg font-secondary">
                  Branch Office: <span> Noida, Uttar Pradesh, India</span>
                </h6>
                <ul className="list-unstyled">
                  <li>
                    <span>Address</span> Farm No. 48, Vatika Farm Soceity,
                    Pushta KG Rd, Asgerpur, Sector 131, Noida, Uttar Pradesh
                    201304
                  </li>
                </ul>
                <div className="b-map-small-holder">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.1198515502265!2d77.35306369999999!3d28.506041599999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce7292d34b815%3A0xf77414000422d5a!2sYeh%20Bhi%20Kuch%20Khaas%20Hai%20Farm%20-%20Best%20Recreation%20Place%20in%20Noida%20%7C%20Weekend%20Staycation!5e0!3m2!1sen!2sin!4v1757666187604!5m2!1sen!2sin"
                    width="100%"
                    height="100"
                     title="Noida"
                    style={{ border: 0 }}
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

              {/* Branch Canada */}
              <div className="b-contact-info">
                <h6 className="contact-info-title customPseudoElBg font-secondary">
                  Branch Office: <span> Canada</span>
                </h6>
                <ul className="list-unstyled">
                  <li>
                    <span>Address</span> 83 Elgin Dr, Brampton, ON L6Y 1A9, Canada
                  </li>
                  <li>
                    <span>Email</span>
                    <Link to="mailto:support@isolsgroup.com">support@isolsgroup.com</Link> &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span> phone</span>
                    <Link to="tel:+14373768000">
                      +1(437) 376 8000 (US/Canada/Mexico)
                    </Link>
                  </li>
                </ul>
                <div className="b-map-small-holder">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.9857262890087!2d-79.750355884633!3d43.6692666791208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b15797713b709%3A0x906ab063cd629050!2sISOLS+GROUP+CANADA+INC!5e0!3m2!1sen!2sin!4v1555527741821!5m2!1sen!2sin"
                    width="100%"
                    height="100"
                     title="Canada"
                    style={{ border: 0 }}
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
